module.exports = __webpack_public_path__ + "img/undraw_empty.06ad20ac.svg";